export default {"src":"https://static.eleduck.com/_next/static/media/flash.624a86c0.svg","height":192,"width":192,"blurWidth":0,"blurHeight":0};